import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

export const ContactCallToActionContainer = styled('div', {
  base: {
    textAlign: 'center',
    m: 'auto',
    flexDirection: 'column',
    gap: '8px',
    display: 'flex',
    alignItems: 'center',
  },
});

export const ContactCallToActionBtn = styled('div', {
  base: {
    width: '200px',
    display: 'inline-block',
  },
});

export const contactTodayTextCss = css({
  color: 'hpxWhite',
  fill: 'hpxWhite',
});
